import * as React from "react";
import { cn } from "@/lib/utils";

export interface SocoAiLogoProps {
  variant: "color" | "mono";
  height: number;
  className?: string;
}

export const SocoAiLogo: React.FC<SocoAiLogoProps> = ({ variant, height, className }) => (
  <img
    src={`https://cdn.socialcoach.io/socoai_${variant}_positive.svg`}
    alt="SocialCoach AI"
    style={{ height }}
    className={cn("w-auto select-none", className)}
    draggable={false}
  />
);
